export const SET_ENTRETIENS_LOADING = "SET_ENTRETIENS_LOADING";
export const SET_ENTRETIENS_ERROR = "SET_ENTRETIENS_ERROR";

export const FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST = "FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST";
export const FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS = "FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS";
export const FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL = "FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL";

export const CREATE_ENTRETIEN_REQUEST = "CREATE_ENTRETIEN_REQUEST";
export const CREATE_ENTRETIEN_SUCCESS = "CREATE_ENTRETIEN_SUCCESS";
export const CREATE_ENTRETIEN_FAIL = "CREATE_ENTRETIEN_FAIL";
export const UPDATE_ENTRETIEN_REQUEST = "UPDATE_ENTRETIEN_REQUEST";
export const UPDATE_ENTRETIEN_SUCCESS = "UPDATE_ENTRETIEN_SUCCESS";
export const UPDATE_ENTRETIEN_FAIL = "UPDATE_ENTRETIEN_FAIL";

export const SEND_INTERVIEW_CALENDAR_REQUEST = "SEND_INTERVIEW_CALENDAR_REQUEST";
export const SEND_INTERVIEW_CALENDAR_SUCCESS = "SEND_INTERVIEW_CALENDAR_SUCCESS";
export const SEND_INTERVIEW_CALENDAR_FAIL = "SEND_INTERVIEW_CALENDAR_FAIL";

export const setEntretiensLoading = (v) => ({
    type: SET_ENTRETIENS_LOADING,
    payload: v,
});

export const setEntretiensError = (msg) => ({
    type: SET_ENTRETIENS_ERROR,
    payload: msg,
});

export const fetchEntretiensByCandidatureRequest = (candidatureId) => ({
    type: FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
    payload: { candidatureId },
});

export const fetchEntretiensByCandidatureSuccess = (candidatureId, data) => ({
    type: FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS,
    payload: { candidatureId, data },
});

export const fetchEntretiensByCandidatureFail = (err) => ({
    type: FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL,
    payload: err,
});

export const createEntretienRequest = (payload) => ({
    type: CREATE_ENTRETIEN_REQUEST,
    payload,
});

export const createEntretienSuccess = (data) => ({
    type: CREATE_ENTRETIEN_SUCCESS,
    payload: data,
});

export const createEntretienFail = (err) => ({
    type: CREATE_ENTRETIEN_FAIL,
    payload: err,
});

export const updateEntretienRequest = (entretienId, payload, calendarPayload = null) => ({
    type: UPDATE_ENTRETIEN_REQUEST,
    payload: { entretienId, payload, calendarPayload },
});

export const updateEntretienSuccess = (data) => ({
    type: UPDATE_ENTRETIEN_SUCCESS,
    payload: data,
});

export const updateEntretienFail = (err) => ({
    type: UPDATE_ENTRETIEN_FAIL,
    payload: err,
});

export const sendInterviewCalendarRequest = (entretienId, actionType, payload) => ({
    type: SEND_INTERVIEW_CALENDAR_REQUEST,
    payload: { entretienId, actionType, payload },
});

export const sendInterviewCalendarSuccess = (data) => ({
    type: SEND_INTERVIEW_CALENDAR_SUCCESS,
    payload: data,
});

export const sendInterviewCalendarFail = (err) => ({
    type: SEND_INTERVIEW_CALENDAR_FAIL,
    payload: err,
});
